import React from 'react';

const ViewContent = ({ children }) => (
    <div className="View-content">
        {children}
    </div>
)

export default ViewContent;


// WEBPACK FOOTER //
// ./components/ViewContent.js